import { cn } from "@/lib/utils";

export const STATUS_ORDER = ["new", "loa_sent", "proposal_sent", "contract_executed", "closed_lost"];

export const STATUS_META = {
  new: { label: "New", cls: "bg-slate-100 text-slate-700 border-slate-200", dot: "bg-slate-400" },
  loa_sent: { label: "LOA Sent", cls: "bg-blue-50 text-blue-700 border-blue-200", dot: "bg-blue-500" },
  proposal_sent: { label: "Proposal Sent", cls: "bg-amber-50 text-amber-700 border-amber-200", dot: "bg-amber-500" },
  contract_executed: { label: "Contract Executed", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "bg-emerald-500" },
  closed_lost: { label: "Closed / Lost", cls: "bg-red-50 text-red-700 border-red-200", dot: "bg-red-500" },
};

export const SERVICE_META = {
  electricity: { label: "Electricity", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  gas: { label: "Natural Gas", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  battery: { label: "VPP Network", cls: "bg-cyan-50 text-cyan-700 border-cyan-200" },
};

export function StatusBadge({ status, className }) {
  const m = STATUS_META[status] || STATUS_META.new;
  return (
    <span className={cn("inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium", m.cls, className)}>
      <span className={cn("h-1.5 w-1.5 rounded-full", m.dot)} />
      {m.label}
    </span>
  );
}

export function ServiceTags({ services = [] }) {
  return (
    <div className="flex flex-wrap gap-1">
      {services.map((s) => {
        const m = SERVICE_META[s] || { label: s, cls: "bg-slate-50 text-slate-600 border-slate-200" };
        return (
          <span key={s} className={cn("rounded border px-1.5 py-0.5 text-[11px] font-medium", m.cls)}>
            {m.label}
          </span>
        );
      })}
    </div>
  );
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return iso;
  }
}

export function Card({ className, children, ...props }) {
  return (
    <div className={cn("rounded-lg border border-line bg-white", className)} {...props}>
      {children}
    </div>
  );
}
